import { RouteItem } from '@eastcoal/router/types/route'

import { JOURNAL_LIST_ROUTE_PAGE_PATH } from './constants/path'
import { JOURNAL_LIST_PAGE_UUID } from './constants/uuid'

export const accountJournalRoute: RouteItem = {
  title: '资金流水',
  path: JOURNAL_LIST_ROUTE_PAGE_PATH,
  uuid: JOURNAL_LIST_PAGE_UUID,
  Component: () => import('./List/index')
}
